import React from 'react';
import Icon from '../../../components/AppIcon';

const StaffPerformance = ({ staff }) => {
  if (!staff || staff?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Staff Performance</h2>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="Users" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No staff performance data available</p>
        </div>
      </div>
    );
  }

  const maxSales = Math.max(...staff?.map(s => s?.sales || 0));

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Staff Performance</h2>
        <Icon name="Award" size={20} className="text-primary" />
      </div>
      
      <div className="space-y-4">
        {staff?.map((member, index) => {
          const salesPercentage = maxSales > 0 ? (member?.sales / maxSales) * 100 : 0;
          const isTopPerformer = index === 0;
          
          return (
            <div key={member?.cashier_id} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  {isTopPerformer && (
                    <Icon name="Trophy" size={16} className="text-warning" />
                  )}
                  <div>
                    <p className="text-sm font-medium text-foreground">{member?.name}</p>
                    <p className="text-xs text-muted-foreground">
                      {member?.transactions} transactions
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-success">
                    ${member?.sales?.toFixed(2)}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    ${(member?.sales / member?.transactions)?.toFixed(2)} avg
                  </p>
                </div>
              </div>
              
              {/* Performance Bar */}
              <div className="w-full bg-accent/30 rounded-full h-2">
                <div
                  className={`h-2 rounded-full transition-all ${
                    isTopPerformer ? 'bg-warning' : 'bg-primary'
                  }`}
                  style={{ width: `${salesPercentage}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>

      {staff?.length > 0 && (
        <div className="mt-6 pt-4 border-t border-border">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Total Team Sales</span>
            <span className="font-semibold text-foreground">
              ${staff?.reduce((sum, s) => sum + (s?.sales || 0), 0)?.toFixed(2)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffPerformance;